// Common javascript function

import { IProduct } from "../store/protectionPlanService/ezs/types";
import { staticURLs } from "../config/urls";
import moment from "moment-timezone";
import { emailMasking } from "./CommonReadonlyMasking";

// Toggle Div -- Use this component but move {status} into button text https://reactstrap.github.io/components/collapse/
export function toggle(id: any, id2: any) {
    const container = document.getElementById(id);
    const button = document.getElementById(id2);
    if (container && button) {
        if (container.style.display !== "none") {
            container.style.display = "none";
            button.setAttribute("aria-expanded", "false");
            const toggleButton = button.querySelector(".btn-toggle-status");
            if (toggleButton) {
                toggleButton.innerHTML = "Show"; // update the button label
            }
        } else {
            container.style.display = "";
            button.setAttribute("aria-expanded", "true");
            const toggleButton = button.querySelector(".btn-toggle-status");
            if (toggleButton) {
                toggleButton.innerHTML = "Hide"; // update the button label
            }
        }
    }
}

export const removeEUPrivateShieldProvatePolicyLink = (resourceValue?: string) => {
    const cotentsToRemove: string[] = [
        ' To\n            read or print our full EU-US Privacy Shield Privacy Policy, click <a\n                href="https://www.identityforce.com/privacy-shield-policy/">here</a>.',
        '\n            To read our full EU-US Privacy Shield Privacy Policy, click&nbsp;<u><a\n                    href="https://www.identityforce.com/privacy-shield-policy/">here</a></u>.',
        ', the IdentityForce Privacy Notice located at the <a\n                    href="https://www.identityforce.com/privacy-shield-policy">Privacy Notice page</a>',
        ', and the IdentityForce EU-US Data Privacy\n            Shield Privacy Policy <a href="https://www.identityforce.com/privacy-shield-policy">here</a>',
        ' To view our EU-US\n            Privacy Shield Policy, please visit <a\n                href="https://www.identityforce.com/privacy-shield-policy">https://www.identityforce.com/privacy-shield-policy</a>.\n        ',
    ];

    let filteredResoruceValue = "";
    if (resourceValue) {
        filteredResoruceValue = resourceValue;
        cotentsToRemove.forEach((item: string) => {
            filteredResoruceValue = filteredResoruceValue.replace(item, "");
        });
    }

    return filteredResoruceValue;
};

export function toggleClass(areaClass: any, buttonId: any) {
    const containers: any = document.getElementsByClassName(areaClass);
    const button: any = document.getElementById(buttonId);

    if (containers && button) {
        for (var i = 0; i < containers.length; i++) {
            if (containers[i].style.display !== "none") {
                containers[i].style.display = "none";
                button.setAttribute("aria-expanded", "false");
                const toggleButton = button.querySelector(".btn-toggle-status");
                if (toggleButton) {
                    toggleButton.innerHTML = "Show"; // update the button label
                }
            } else {
                containers[i].style.display = "";
                button.setAttribute("aria-expanded", "true");
                const toggleButton = button.querySelector(".btn-toggle-status");
                if (toggleButton) {
                    toggleButton.innerHTML = "Hide"; // update the button label
                }
            }
        }
    }
}

//////////////////////////////////////////////////////////////////////////////////
////////////////////////  Decode Encoded Data Function  //////////////////////////
//////////////////////////////////////////////////////////////////////////////////
// @param data - data is the data being passed to be decoded
export function decodeData(data: any) {
    // loop through all objects within the data
    for (var key in data) {
        if (typeof data[key] == "object") {
            // run through data again until there are no more nested objects
            data[key] = decodeData(data[key]);
        } else {
            // if data exists, replace encoded values
            if (data[key].length >= 0) {
                data[key] = data[key]
                    .replace(/&amp;/g, "&")
                    .replace(/&lt;/g, "<")
                    .replace(/&gt;/g, ">")
                    .replace(/&apos;/g, "'")
                    .replace(/&quot;/g, '"')
                    .replace(/&#8216;/g, "‘")
                    .replace(/&#8217;/g, "’")
                    .replace(/&#8220/g, "“")
                    .replace(/&#8221/g, "”")
                    .replace(/&amp;/g, "&")
                    .replace(/&#10;/g, "\n");
            }
        }
    }
    return data;
}

export function calculate_age(birthDate: Date) {
    const todaysDate = new Date();

    let years = todaysDate.getFullYear() - birthDate.getFullYear();

    if (todaysDate.getMonth() < birthDate.getMonth() || (todaysDate.getMonth() === birthDate.getMonth() && todaysDate.getDate() < birthDate.getDate())) {
        years--;
    }

    return years;
}

export function isValidDate(date: { day: string; month: string; year: string }) {
    if (!date) return false;
    if (!date.day) return false;
    if (!date.month) return false;
    if (!date.year) return false;

    const dateFormat = "DD-MM-YYYY";
    return moment(`${date.day}-${date.month}-${date.year}`, dateFormat).isValid();
}

export function groupByKey(array: any, key: string) {
    if (array == null) {
        return null;
    } else {
        return array.reduce((hash: any, obj: any) => {
            if (obj[key] === undefined) return hash;
            return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) });
        }, {});
    }
}

export function groupByValue(array: any, val: any) {
    if (array == null) {
        return null;
    } else {
        return array.reduce((acc: any, obj: any) => {
            const key = obj[val];
            if (!acc[key]) {
                acc[key] = [];
            }
            // Add object to list for given key's value
            acc[key].push(obj);
            return acc;
        }, {});
    }
}

export function getContactUsURL(partnerId?: number, idfPartner?: Boolean) {
    const IDFPseudoPartnerID = 536;
    const IDFBrandedPartner = 542;
    const contactUsURL =
        partnerId && (partnerId === IDFPseudoPartnerID || idfPartner || partnerId === IDFBrandedPartner)
            ? staticURLs.IDFContactUsPage
            : `${decodeURIComponent(encodeURIComponent(window.location.origin)).toString()}/WhyUs/ContactUs/tabid/116/Default.aspx`;
    return contactUsURL;
}

export function formatEINEditView(ein?: string) {
    if (!ein) return "";
    if (!ein.match(/^[0-9]{9}$/)) return ein;
    return `${ein.substring(0, 2)}-${ein.substring(2, ein.length)}`;
}

export function maskEIN(ein?: string) {
    if (!ein) return "";
    if (ein.length <= 4) return ein;
    const unmaskedLast4EINCharacters = ein.substring(ein.length - 4);
    const maskedEINCharacters = ein.substring(0, ein.length - 4).replace(/([a-zA-Z0-9-])/g, "*");
    return `${maskedEINCharacters}${unmaskedLast4EINCharacters}`;
}

export function productSortingNullLast(ascending: boolean) {
    return function (a: IProduct, b: IProduct) {
        // equal items sort equally
        if (a.orderBy === b.orderBy) {
            return 0;
        }
        // nulls sort after anything else
        else if (a.orderBy === null || a.orderBy === undefined) {
            return -1;
        } else if (b.orderBy === null || b.orderBy === undefined) {
            return 1;
        }
        // otherwise, if we're ascending, lowest sorts first
        else if (ascending) {
            return a.orderBy < b.orderBy ? -1 : 1;
        }
        // if descending, highest sorts first
        else {
            return a.orderBy < b.orderBy ? 1 : -1;
        }
    };
}

export function downloadJsonToCsv(data: any[], fileName: string) {
    const replacer = (key: any, value: any) => (value === null ? null : value);
    const header = Object.keys(data[0]);
    let csv: any = data.map((row) => header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(","));
    csv.unshift(header.map((item) => item.toUpperCase()).join(","));
    csv = csv.join("\r\n");
    var link = document.createElement("a");
    link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURIComponent(csv));
    link.setAttribute("download", fileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const MonitorType = {
    All: 0,
    BankAccountMonitoring: 1,
    CreditCardMonitoring: 2,
    EmailAddressMonitoring: 3,
    PhoneNumberMonitoring: 4,
    DriverLicenseMonitoring: 5,
    PassportMonitoring: 6,
    MedicalAccountMonitoring: 7,
    MaidenNameMonitoring: 8,
    SocialMediaMonitoring: 9,
    BankAndCreditCardMonitoring: 10,
    IBanAccountMonitoring: 11,
};

export { MonitorType };

export const getCurrencyFormat = (country: string) => {
    if (!(country === "US")) {
        return "USD ";
    }
    return "$";
};

export const validateCardExpiry = (month: string, year: string) => {
    const cardMaxYear = moment(new Date(), "DD-MM-YYYY").add(9, "year").format("YY");
    const currentMonth = moment(new Date(), "DD-MM-YYYY").format("MM");
    const currentYear = moment(new Date(), "DD-MM-YYYY").format("YY");
    if (currentYear === year) {
        return Number(month) >= Number(currentMonth);
    }
    return Number(cardMaxYear) >= Number(year) && Number(year) > Number(currentYear);
};

export const toggleFullScreenLoader = (isLoading: boolean) => {
    const root = document.getElementById("root");
    const rootChild = root?.firstElementChild;

    if (isLoading) {
        rootChild?.classList.add("loading");
    } else {
        rootChild?.classList.remove("loading");
    }
};

export const calculateAgeInDecimal = (date: any) => {
    const today = moment();
    const birthDate = moment(date, "MM/DD/YYYY");

    const ageYears = today.diff(birthDate, "years");
    birthDate.add(ageYears, "years");
    const ageDays = today.diff(birthDate, "days");

    return Number(`${ageYears}.${ageDays}`);
};

export const getUserNameOrMaskedEmail = (emailOrUserId: any) => {
    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailOrUserId);

    if(isEmail){
        return emailMasking(emailOrUserId)
    }

    return emailOrUserId
}

export const checkIsEmail = (emailOrUserId: any) => {
    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailOrUserId);

    if(isEmail){
        return true;
    }

    return false;
}
